import React from 'react';

export interface ViewToggleOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface ViewToggleProps {
  value: string;
  onChange: (value: string) => void;
  options: ViewToggleOption[];
}

/**
 * ViewToggle — стандартный переключатель режима просмотра.
 * Используется в PageToolbar (справа): Approvals (Split/List), TOIL (Calendar/List) и т.д.
 * Стили хранятся внутри компонента — не переопределять снаружи.
 */
const ViewToggle: React.FC<ViewToggleProps> = ({ value, onChange, options }) => (
  <div style={{
    display: 'flex',
    borderRadius: 8,
    border: 'var(--border-input)',
    overflow: 'hidden',
    background: 'var(--btn-user-form)',
    flexShrink: 0,
  }}>
    {options.map((opt, idx) => (
      <button
        key={opt.value}
        type="button"
        onClick={() => onChange(opt.value)}
        style={{
          height: 32,
          padding: '0 14px',
          fontSize: 12,
          fontWeight: 700,
          cursor: 'pointer',
          border: 'none',
          borderRight: idx < options.length - 1 ? 'var(--border-input)' : 'none',
          transition: 'background .15s, color .15s',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: value === opt.value ? 'linear-gradient(135deg,#2563eb,#7c3aed)' : 'transparent',
          color: value === opt.value ? 'white' : 'var(--text-color-calendar-week)',
        }}
      >
        {opt.icon && opt.icon}
        {opt.label}
      </button>
    ))}
  </div>
);

export default ViewToggle;
